export default "__VITE_ASSET__CCXH3qFl__"